import _ from 'lodash';

function handleEdgeError(edgeErrors, oldUIErrors) {
    let hasNewIssues = false;
    let containsError = false;
    const issuesList = [];
    const fieldIssues = _.get(edgeErrors, `validationIssues.fieldIssues`, []);
    const issues = _.get(edgeErrors, `validationIssues.issues`, []);

    if (fieldIssues.length > 0 || issues.length > 0) {
        let errorMessages = [];
        const issuesDecription = _.uniq(_.map(issues, (issue) => _.pick(issue, 'type', 'reason')));

        issuesDecription.map(item => {
            const findItem = issuesList.find(x => x.reason === item.reason);

            if (!findItem) {issuesList.push(item);}
        });

        if (issuesList.length > 0) {
            errorMessages = _.uniqBy((_.filter(issues, (issue) => issue.type === 'error')), 'reason');
        }


        hasNewIssues = (!_.isEqual(_.map(oldUIErrors, 'reason'), _.map(issuesList, 'reason')));
        containsError = !!(((!_.isUndefined(errorMessages)) && errorMessages.length > 0));
    }

    const retObj = {
        "hasNewIssues": hasNewIssues,
        "containsError": containsError,
        "issuesList": issuesList
    };

    return retObj;
}


function getNotificationsContent (issues) {
    return issues.map((data, index) => ({
            id: `issues${index}`,
            type: 'element',
            component: 'InlineNotification',
            componentProps: {
                isDismissable: (data.type === 'warning'),
                type: data.type,
                message: data.reason,
                messageProps: {
                  "warning": "Warning" ,
                  "error":"Error:",
                }
            }
        }));
}

function unSetIsValidationReqFlag (obj, indent) {
     for (const i in obj) {
            if (Array.isArray(obj[i]) || typeof obj[i] === 'object') {
                unSetIsValidationReqFlag(obj[i], `${indent} > ${i} > `);
            } else if (i === 'isValidationReq' || i === 'isValidationRequired') {
                // eslint-disable-next-line no-param-reassign
                obj[i] = false
            }
        }
}

export default {
    handleEdgeError,
    getNotificationsContent,
    unSetIsValidationReqFlag
};